import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
/********************************************************************************
 * Copyright (c) 2020 TypeFox and others
 *
 * This program and the accompanying materials are made available under the
 * terms of the Eclipse Public License v. 2.0 which is available at
 * http://www.eclipse.org/legal/epl-2.0.
 *
 * SPDX-License-Identifier: EPL-2.0
 ********************************************************************************/
import { useState } from 'react';
import { Popover } from '@mui/material';
export const HoverPopover = props => {
    const [anchor, setAnchor] = useState(null);
    return (_jsxs(_Fragment, { children: [_jsx("div", { className: props.className, "aria-haspopup": 'true', "aria-owns": anchor ? props.id : undefined, onMouseEnter: event => setAnchor(event.currentTarget), onMouseLeave: () => setAnchor(null), children: props.children }), _jsx(Popover, { id: props.id, open: Boolean(anchor), anchorEl: anchor, anchorOrigin: { vertical: 'bottom', horizontal: 'left' }, onClose: () => setAnchor(null), disableRestoreFocus: true, sx: {
                    pointerEvents: 'none',
                    '& .MuiPopover-paper': {
                        p: 1,
                        maxWidth: '80%'
                    }
                }, children: props.popupContent })] }));
};
//# sourceMappingURL=hover-popover.js.map